import type { NWorkSchedule } from '@pages/WorkSchedule/WorkSchedule.types';

export const handleSpecificDays = (
  selectedDays: NWorkSchedule.SelectedDays
): NWorkSchedule.Day[] => {
  const result: NWorkSchedule.Day[] = [];
  for (const [key, value] of Object.entries(selectedDays)) {
    if (value) {
      result.push(key as NWorkSchedule.Day);
    }
  }
  return result;
};
